import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./styles.css";
import { installBrowserApi } from "./ai/browserApi.ts";

installBrowserApi();

const root = document.getElementById("root");
if (!root) {
  throw new Error("React root element not found.");
}

createRoot(root).render(<App />);
